module.exports = __webpack_public_path__ + "img/5.ae8d8299.png";